<p *ngFor="let message of messageService.messages">
        <ngb-alert type="{{message.tipo}}" (close)="close(message)">{{ message.raw }}</ngb-alert>
</p>
<ngb-alert *ngIf="messageService.successMessage" type="success" (close)="close(messageService.successMessage)" [dismissible]="true">
        {{ messageService.successMessage }}</ngb-alert>

<ngb-alert *ngIf="messageService.errorMessage" type="danger" (close)="errorMessage = null" [dismissible]="true">
        {{ messageService.errorMessage }}</ngb-alert>
